module.exports = __webpack_public_path__ + "static/media/wsp-icon.182086e0.png";